module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/suede@3x_4e00fb.jpg";